"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tariff = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const iconItemConfig_1 = require("./iconItemConfig");
exports.tariff = {
    title: 'Economy Plus',
    detailsConfig: [
        iconItemConfig_1.iconItemsConfig.meal,
        iconItemConfig_1.iconItemsConfig.briefcase,
        iconItemConfig_1.iconItemsConfig.baggage,
        iconItemConfig_1.iconItemsConfig['calendar-mark'],
    ],
    detailedDescription: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant/TariffConfig/economyPlus:DetailedDescription', description: 'Rate `economyPlus` detailed HTML description', defaultMessage: '<p>Based on the selected tariff, only cabin luggage is allowed. Please consider the luggage and tariff restrictions.</p><p>All stated times are local times at the origin of departure.</p><p>The states prices apply to one flight for one adult person. Depending on the selected payment method, additional fees can accrue. The tariffs are not guaranteed until you receive a booking confirmation.</p>', values: {
            p: (chunk) => react_1.default.createElement("p", null, chunk),
        } })),
};
//# sourceMappingURL=economy-plus.js.map